/** Match address-book ID masking: last 6 digits visible. */
export function maskIdNumberForDisplay(value: string | null | undefined): string {
  if (!value) return '';
  const compact = String(value).replace(/\s+/g, '');
  if (!compact) return '';
  if (compact.includes('*')) return compact;
  if (compact.length <= 6) return compact;
  return `${'*'.repeat(compact.length - 6)}${compact.slice(-6)}`;
}

/** Same rule as ID: last 6 digits visible. */
export function maskCellNumberForDisplay(value: string | null | undefined): string {
  if (!value) return '';
  const asStored = String(value).replace(/\s+/g, '');
  if (!asStored) return '';
  // Already masked — keep as returned (do not strip * and expose a short digit tail).
  if (asStored.includes('*')) return asStored;
  const digits = asStored.replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length <= 6) return digits;
  return `${'*'.repeat(digits.length - 6)}${digits.slice(-6)}`;
}

/**
 * DOVS list subject is typically "maskedId / maskedCell".
 * Re-mask segments when they are still full digit values.
 */
export function formatDovsSubjectDisplay(lookupDisplay: string | null | undefined): string {
  if (!lookupDisplay) return '—';
  const parts = lookupDisplay.split(' / ');
  if (parts.length < 2) {
    return maskIdNumberForDisplay(lookupDisplay) || lookupDisplay;
  }
  const idPart = maskIdNumberForDisplay(parts[0]) || parts[0];
  const cellPart = maskCellNumberForDisplay(parts[1]) || parts[1];
  const rest = parts.slice(2);
  return rest.length ? `${idPart} / ${cellPart} / ${rest.join(' / ')}` : `${idPart} / ${cellPart}`;
}
